import {Component, HostBinding, Input} from "@angular/core";

@Component({
    selector: "fui-simple-row",
    styleUrls: ["./simple-row.component.scss"],
    templateUrl: "./simple-row.component.html"
})
export class FUISimpleRowComponent {
    @HostBinding("class.labelled") @Input() label: string;
    @Input() i18nParams: any = {};
}
